import { VegaButton, VegaFont, VegaPageNotification } from '@globalpayments/vega-react';

import DetailsModal from '../../../components/detailsModal';
import { UserSummary } from '../../../types/users';

interface UpdateActiveDialogProps {
  error?: Error | null;
  isPending: boolean;
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
  user?: UserSummary;
}

/** Confirms activation changes, including potentially disruptive deactivation. */
const UpdateActiveDialog = ({ error, isPending, onClose, onSubmit, open, user }: UpdateActiveDialogProps) => {
  const action = user?.isActive ? 'Deactivate' : 'Reactivate';

  return (
    <DetailsModal
      backdrop="static"
      footerActions={
        <VegaButton
          disabled={!user || isPending}
          label={isPending ? `${action} user` : action}
          onVegaClick={onSubmit}
          variant={user?.isActive ? 'secondary' : 'primary'}
        />
      }
      modalTitle={`${action} user`}
      onClose={onClose}
      open={open}>
      {error && (
        <VegaPageNotification
          duration={0}
          message={error.message}
          notificationTitle={`${action} failed`}
          type="error"
        />
      )}
      <VegaFont as="p">
        {action} {user?.displayName ?? user?.email}?
      </VegaFont>
    </DetailsModal>
  );
};

export default UpdateActiveDialog;
